<template>
  <div class="about">
    <top-nav></top-nav>
    <banner :bgImage="bgImage"></banner>
    <section class="reyzaerTechnology">
      <div class="aboutReyzarBox">
        <div class="aboutReyzarTit">
          <div class="aboutReyzarTitTop">睿哲科技</div>
          <div class="aboutReyzarTitMid">REYZAR&nbsp;&nbsp;TECHNOLOGY</div>
          <!-- <div class="aboutReyzarTitButtom">下一代互联网解决方案领导品牌</div> -->
          <div class="aboutReyzarTitButtom">专注于下一代互联网综合解决方案</div>
        </div>
        <div class="aboutReyzarPic" style="position:relative;">
          <!--   <div class="playVideoBg"><img src="../../../static/images/play.png" onClick="play()"></div> -->
          <img src="../../../static/images/aboutReyzarPic.jpg?011801" width="1200" height="256">
          <div class="aboutReyzarConn">
            <br>
            <p>
              睿哲科技（睿哲科技股份有限公司）是一家专注于下一代互联网（IPv6）技术研发的新三板高新技术企业，专业提供IPv6演进的综合解决方案。公司在物联网、大数据、云计算、智慧城市等领域为客户提供包括方案设计、网络集成、应用开发和技术支撑等多层面的产品和服务，是国内下一代互联网综合解决方案提供商。</p>
            <p>
              公司拥有多项自主知识产权，包括国际标准、专利、专著和论文等丰硕研究成果，其全国首创的IPv6应用迁移技术（SPACE6）已得到大规模商用，成为事实上的行业标准。</p>
            <p>
              睿哲科技总部及研发中心位于广州，分别在北京、成都、新疆等地设有子公司，在香港、沈阳等地设有分支机构和办事处，为遍及全国及海外的用户提供高科技定制化服务。</p>
          </div>
        </div>
        <!-- 弹窗 -->
        <!-- <div class="modalBg">
            <div class="modalWarp">
                <video id="video1" src="video/reyzarVideo.mp4" controls></video>
                <div class="closeBg" onClick="rePlay()"><img src="../../../static/images/closeBg.png"></div>
            </div>
        </div> -->
      </div>
    </section>

    <section class="reyzarPosition">
      <div class="aboutReyzarBox">
        <div class="aboutReyzarTit">
          <div class="aboutReyzarTitTop">市场地位</div>
          <div class="aboutReyzarTitMid" style="letter-spacing: 3px">
            market&nbsp;&nbsp;position
          </div>
          <div class="aboutReyzarTitButtom">
            中国资本市场专注于下一代互联网的第一股
          </div>
        </div>
        <div class="reyzarPositionData">
          <ul>
            <li>
              <div class="reyzarPositionDataBox">
                <div class="reyzarPositionDataBoxIn">
                  <div class="reyzarPositionDataNum">60<span>%</span></div>
                  <div class="reyzarPositionDataConn">市场占有率超过</div>
                </div>
              </div>
            </li>
            <li>
              <div class="reyzarPositionDataBox">
                <div class="reyzarPositionDataBoxIn">
                  <div class="reyzarPositionDataNum">72<span>%</span></div>
                  <div class="reyzarPositionDataConn">
                    下一代互联网建设城市占有率
                  </div>
                </div>
              </div>
            </li>
            <li>
              <div class="reyzarPositionDataBox">
                <div class="reyzarPositionDataBoxIn">
                  <div class="reyzarPositionDataNum">23<span>座</span></div>
                  <div class="reyzarPositionDataConn">示范城市占有量</div>
                </div>
              </div>
            </li>
          </ul>
        </div>
        <div class="reyzarPositionConn">
          依靠强大的科研创新实力和丰富的运营管理经验，睿哲科技一路稳健发展。在国家下一代互联网示范城市建设中，<br/>睿哲科技分别成功支撑了上海、广州、深圳、武汉等13个示范城市，占首批所有示范城市的72%，进一步夯实睿哲科技在IPv6领域的技术与市场竞争优势。
        </div>
        <div class="reyzarPositionTime">
          <i></i>
          <div class="reyzarPositionTimeBox" style="top: 0; left: 0">
            <div class="reyzarPositionConn">
              2016年1月<br/>睿哲科技完成A轮融资获得两倍超额认购
            </div>
            <div class="reyzarPositionTimeCircle"></div>
          </div>
          <div class="reyzarPositionTimeBox" style="bottom: 0; left: 148px; width:402px">
            <div class="reyzarPositionTimeCircle"></div>
            <div class="reyzarPositionConn">
              2016年11月<br/>睿哲科技成功挂牌成为“中国资本市场专注于下一代互联网的第一股”
            </div>
          </div>
          <div class="reyzarPositionTimeBox" style="top: 0; right: 430px">
            <div class="reyzarPositionConn">
              2017年12月<br/>睿哲科技的市场占有率已经超过60%
            </div>
            <div class="reyzarPositionTimeCircle"></div>
          </div>
          <div class="reyzarPositionTimeBox" style="bottom: 0; right: 110px; width:355px">
            <div class="reyzarPositionTimeCircle"></div>
            <div class="reyzarPositionConn">
              2020年11月<br/>公司承建“雄安新一代网络实验室”，助力雄安新区打造全球首个全域纯IPv6“未来之城”。
            </div>
          </div>
          <div class="reyzarPositionTimeBox" style="top: -31px; right: -93px;width:355px">
            <div class="reyzarPositionConn" style="margin-bottom: 0px">
              2025年4月<br/>牵头成立“雄安新区未来网络创新研究院”<br/>推动IPv6单栈部署
            </div>
            <div class="reyzarPositionTimeCircle"></div>
          </div>

        </div>
      </div>
    </section>
    <section class="reyzarConcept">
      <div class="aboutReyzarBox">
        <div class="aboutReyzarTit">
          <div class="aboutReyzarTitTop">睿哲理念</div>
          <div class="aboutReyzarTitMid" style="letter-spacing: 3px">
            reyzar&nbsp;&nbsp;concept
          </div>
          <div class="aboutReyzarTitButtom">
            我们相信：客户的成功才是我们的成功
          </div>
        </div>
        <div class="reyzarConceptBox clearfix">
          <ul>
            <li>
              <div class="reyzarConceptPic">
                <img src="../../../static/images/reyzarConceeptPic1.png"/>
              </div>
              <div class="reyzarConceptTit">专业高效研发团队</div>
            </li>
            <li class="long">
              <div class="reyzarConceptPic">
                <img src="../../../static/images/reyzarConceeptPic2.png"/>
              </div>
              <div class="reyzarConceptTit">精准定制化解决方案</div>
            </li>
            <li>
              <div class="reyzarConceptPic">
                <img src="../../../static/images/reyzarConceeptPic3.png"/>
              </div>
              <div class="reyzarConceptTit">高满意度优质服务</div>
            </li>
            <li class="long">
              <div class="reyzarConceptPic">
                <img src="../../../static/images/reyzarConceeptPic4.png"/>
              </div>
              <div class="reyzarConceptTit">全方位满足客户需求</div>
            </li>
            <li>
              <div class="reyzarConceptPic">
                <img src="../../../static/images/reyzarConceeptPic5.png"/>
              </div>
              <div class="reyzarConceptTit">真诚互信合作共赢</div>
            </li>
          </ul>
        </div>
      </div>
    </section>
    <section class="reyzarPosition">
      <div class="aboutReyzarBox">
        <div class="aboutReyzarTit">
          <div class="aboutReyzarTitTop">合作伙伴</div>
          <div class="aboutReyzarTitMid" style="letter-spacing: 3px">
            reyzar&nbsp;&nbsp;partner
          </div>
          <div class="aboutReyzarTitButtom">
            我们期待与您携手合作&nbsp;&nbsp;共同谱写辉煌乐章
          </div>
        </div>
        <div class="reyzarPartnerLogo">
          <Carousel v-model="logoValue" dots="none" arrow="always">
            <CarouselItem>
              <li><img src="../../../static/images/partners1.jpg?0219"/></li>
            </CarouselItem>
            <CarouselItem>
              <li><img src="../../../static/images/partners2.jpg?0219"/></li>
            </CarouselItem>
            <CarouselItem>
              <li><img src="../../../static/images/partners3.jpg?0219"/></li>
            </CarouselItem>
            <CarouselItem>
              <li><img src="../../../static/images/partners4.jpg?0219"/></li>
            </CarouselItem>
          </Carousel>
        </div>
      </div>
    </section>
    <section class="reyzarConcept">
      <div class="contactReyzarBox">
        <div class="aboutReyzarTit">
          <div class="aboutReyzarTitTop">联系我们</div>
          <div class="aboutReyzarTitMid" style="letter-spacing: 3px">
            Contact&nbsp;&nbsp;reyzar
          </div>
          <div class="aboutReyzarTitButtom">
            共赢未来&nbsp;共同开创下一代互联网新时代
          </div>
        </div>
        <div class="contactReyzarConn clearfix">
          <div class="contactReyzarMap">
            <img src="../../../static/images/map_new.png"/>
          </div>
          <div class="contactReyzarOther">
            <ul>
              <li>睿哲科技股份有限公司</li>
              <!-- 只修改这一行的样式，添加flex布局确保图标和文字对齐 -->
              <li style="display: flex; align-items: center; white-space: nowrap;">
                <img src="../../../static/images/map-icon01.png" alt="" style="flex-shrink: 0;"/><span style="flex: 1; white-space: nowrap;">地址：广州市天河区临江大道789号 金融城天际广场A座10层1001</span>
              </li>
              <!-- <li>
                <img src="../../../static/images/map-icon02.png" alt="" /><span
                  >电话：020-3829 9023</span
                >
              </li> -->
              <li>
                <img src="../../../static/images/map-icon04.png" alt=""/><span
              >手机：13360033360</span
              >
              </li>
              <li>
                <img src="../../../static/images/map-icon03.png" alt=""/><span
              >邮箱：info@reyzar.com</span
              >
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
    <bottom-footer></bottom-footer>
  </div>
</template>

<script>
import topNav from "@/components/topNav";
import bottomFooter from "@/components/bottomFooter.vue";
import banner from "@/components/banner.vue";
// 如果需要使用Carousel，确保引入element-ui组件
// import { Carousel, CarouselItem } from 'element-ui';

export default {
  name: "about",
  data() {
    return {
      bgImage: '../../../static/images/aboutReyzarBanner.jpg?011801',
      logoValue: 0,
      showMask: false,
    };
  },

  components: {
    topNav,
    bottomFooter,
    banner,
    // Carousel,
    // CarouselItem
  },

  computed: {},

  mounted() {
  },

  methods: {},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
@import "../../assets/css/global";

.about {
  .reyzaerTechnology,
  .reyzarPosition,
  .reyzarConcept {
    width: 100%;
    height: auto;
    color: #818181;
  }

  .aboutReyzarPic {
    width: 100%;
    height: auto;
    padding-bottom: 20px;
    position: relative;

    img {
      width: 100%;
      display: block;
    }

    .aboutReyzarConn {
      width: 100%;
      height: auto;

      p {
        width: 100%;
        line-height: 36px;
        font-size: 18px;
        text-indent: 36px;
        text-align: justify;
      }
    }
  }

  .reyzarPosition {
    background-color: #f8f8f8;

    .reyzarPositionData {
      width: 100%;
      height: 260px;
      padding-bottom: 80px;

      ul {
        display: -webkit-box;
        display: -moz-box;
        display: -ms-flexbox;
        display: -webkit-flex;
        display: flex;

        li {
          -webkit-box-flex: 1;
          -moz-box-flex: 1;
          -webkit-flex: 1;
          -ms-flex: 1;
          flex: 1;
          text-align: center;

          .reyzarPositionDataBox {
            width: 180px;
            height: 180px;
            border: 8px solid #ddd;
            display: inline-block;
            position: relative;

            .reyzarPositionDataBoxIn {
              width: 144px;
              height: auto;
              position: absolute;
              top: 50%;
              left: 50%;
              transform: translate(-50%, -50%);

              .reyzarPositionDataNum {
                width: 144px;
                line-height: 72px;
                font-size: 72px;
                font-weight: bold;
                text-align: center;

                span {
                  font-size: 36px;
                  font-weight: bold;
                }
              }

              .reyzarPositionDataConn {
                width: 100%;
                line-height: 30px;
                font-size: 18px;
                text-align: center;
                margin-top: -10px;
              }
            }
          }
        }
      }
    }

    .reyzarPositionConn {
      width: 106%;
      line-height: 30px;
      font-size: 18px;
      text-align: center;
    }

    .reyzarPositionTime {
      width: 1200px;
      height: 141px;
      margin: 70px auto 0;
      position: relative;

      i {
        width: 100%;
        height: 1px;
        border-top: 1px solid #999a9b;
        position: absolute;
        left: 0;
        top: 71px;
      }

      .reyzarPositionTimeBox {
        width: auto;
        height: 82px;
        position: absolute;

        .reyzarPositionConn {
          width: 100%;
          line-height: 30px;
          font-size: 18px;
          text-align: center;
        }

        .reyzarPositionTimeCircle {
          width: 16px;
          height: 16px;
          border: 2px solid #818181;
          border-radius: 50%;
          background-color: #f8f8f8;
          margin: 4px auto;
        }
      }
    }
  }

  .reyzarConceptBox {
    width: 100%;
    height: auto;

    // 改为Flex布局，让理念项均匀分布
    ul {
      display: flex;
      justify-content: space-around; // 项之间均匀分布
      align-items: center;
      padding: 0; // 清除ul默认内边距
      margin: 0; // 清除ul默认外边距
      list-style: none; // 清除默认列表样式
    }

    // 每个理念项：去掉固定宽度，设置最小宽度+不换行
    li {
      flex: 0 0 auto; // 不缩放，自适应内容宽度
      min-width: 220px; // 最小宽度（适配最长文字）
      height: auto;
      margin: 0; // 清除原有的margin-right
      text-align: center; // 内容（图片+文字）居中对齐

      // 针对更长的文字（如“精准定制化解决方案”）微调最小宽度
      &.long {
        min-width: 240px;
      }

      .reyzarConceptPic {
        width: 141px;
        height: 140px;
        margin: 0 auto; // 图片在项内居中

        img {
          width: 100%;
          height: 100%;
          display: block;
          border-radius: 50%; // 确保图片是圆形（和截图一致）
          object-fit: cover; // 图片适配容器不拉伸
        }
      }

      .reyzarConceptTit {
        width: 100%;
        line-height: 22px;
        font-size: 22px;
        text-align: center;
        padding-top: 20px;
        white-space: nowrap; // 强制文字不换行
        overflow: visible; // 确保文字完整显示（不裁剪）
      }
    }
  }

  .reyzarPartnerLogo {
    width: 100%;
    height: 280px;
    overflow: hidden;
  }

  .contactReyzarBox {
    width: 1200px;
    height: auto;
    padding: 95px 0;
    margin: 0 auto;

    .contactReyzarConn {
      width: 100%;
      height: auto;
      background: none;

      .contactReyzarMap {
        width: 602px;
        height: 402px;
        float: left;

        img {
          width: 100%;
          display: inline-block;
        }
      }

      .contactReyzarOther {
        width: 100%;
        height: auto;
        padding: 43px 0;
        padding-left: 706px;

        li {
          width: 100%;
          line-height: 36px;
          font-size: 16px;
          color: #818181;
          padding-bottom: 36px;
          float: inherit;
          text-align: left;

          &:first-of-type {
            line-height: 20px;
            font-size: 20px;
            font-weight: bold;
          }

          &:last-of-type {
            padding-bottom: 0;
          }

          img {
            width: 36px;
            display: inline-block;
            vertical-align: middle;
          }

          span {
            font-size: 16px;
            vertical-align: middle;
            margin-left: 10px;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/about/about.vue